var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("simple-list", {
    ref: "list",
    staticClass: "upcoming-stays",
    attrs: { "default-limit": 4 },
    scopedSlots: _vm._u([
      {
        key: "card-template",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "ul",
              { staticClass: "my-5" },
              _vm._l(Object.keys(item), function (prop) {
                return _c(
                  "li",
                  { key: prop },
                  [
                    prop === "ImageUrl"
                      ? [_c("img", { attrs: { src: item[prop], alt: "" } })]
                      : [
                          _c("strong", [_vm._v(_vm._s(prop) + ":")]),
                          _vm._v(" " + _vm._s(item[prop]) + "\n        "),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
          ]
        },
      },
      {
        key: "no-items",
        fn: function () {
          return [
            _c("div", { staticClass: "no-items" }, [
              _vm._v("\n      " + _vm._s(_vm.noItemsText) + "\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "no-items" },
              [
                _vm._v("\n      " + _vm._s(_vm.statusMessage) + "\n      "),
                _vm.isLoading ? _c("loading-dots") : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }